import { Link } from 'react-router-dom';
import ThemeToggle from '../common/ThemeToggle';
import UserMenu from './UserMenu';

export default function PublicLogoRow() {
  return (
    <div className="flex items-center justify-between px-4 py-3 sm:px-6 md:px-12 lg:px-20 sm:py-0 border-b border-[#E5E5E5] dark:border-gray-700">
      <div className="sm:pt-[1.5rem] sm:pb-[1.5rem] md:pt-[1.9375rem] md:pb-[2.1875rem]">
        <Link to="/" aria-label="home">
          {/* Light mode logo */}
          <img
            src="https://d1qf1106vb1ual.cloudfront.net/static/logo.svg"
            alt="Aone Institute"
            className="h-8 w-auto sm:h-[2.125rem] sm:w-[10rem] dark:hidden"
          />
          {/* Dark mode logo - white text with colored A */}
          <img
            src="/assets/logo-dark.svg"
            alt="Aone Institute"
            className="h-8 w-auto sm:h-[2.125rem] sm:w-[10rem] hidden dark:block"
          />
        </Link>
      </div>

      <div className="flex items-center gap-1">
        <ThemeToggle />
        <UserMenu className="sm:hidden" />
      </div>
    </div>
  );
}
